import type { EntitiesToCreateComment } from '@entities/common/Comments/comments';
import { useDeleteCommentMutation } from '@entities/common/commonQueries/index.ts';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  DropdownItem,
  DropdownMenuWithButton,
  useMenuDropdown,
} from '@shared/ui/menus/dropdown-menu/index.ts';

export type CommentDropMenuPT = EntitiesToCreateComment & {
  commentId: string;
  isAuthor: boolean;
  isContentAuthor: boolean;
  onWatchProfile: () => void;
  className?: string;
  canWatchProfile?: boolean;
};

export const CommentDropMenu = memo(
  ({
    isAuthor,
    commentId,
    className,
    isContentAuthor,
    onWatchProfile,
    article,
    program,
    canWatchProfile,
  }: CommentDropMenuPT) => {
    const [deleteComment] = useDeleteCommentMutation();
    const navigate = useNavigate();
    const { menuRef, handleToggleDropdown, isMenuOpen, handleAction } = useMenuDropdown({});
    if (!isAuthor && !isContentAuthor && !canWatchProfile) {
      return undefined;
    }
    return (
      <DropdownMenuWithButton
        smallButton
        isMenuOpen={isMenuOpen}
        onMenuBtnClick={handleToggleDropdown}
        menuRef={menuRef}
        wrapperClassName={className}
      >
        {isAuthor && (
          <DropdownItem
            onClick={handleAction(() =>
              navigate(commentId, {
                state: { article, program, pageTitle: isContentAuthor ? 'Ответ' : 'Мой отзыв' },
              })
            )}
          >
            Изменить
          </DropdownItem>
        )}

        {canWatchProfile && !isAuthor && (
          <DropdownItem onClick={onWatchProfile}>Смотреть профиль</DropdownItem>
        )}

        {(isAuthor || isContentAuthor) && (
          <DropdownItem
            onClick={handleAction(async () => await deleteComment({ commentId, article, program }))}
          >
            Удалить
          </DropdownItem>
        )}
      </DropdownMenuWithButton>
    );
  }
);
